module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_DoubleLeft_16"],"path":[{"$":{"d":"M13.65,14.24,6.85,8l6.8-6.24L15,3.24,9.81,8,15,12.76Zm-5.2-1.47L3.26,8l5.2-4.76L7.1,1.76.3,8l6.8,6.24Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_DoubleLeft_16.svg
// module id = NnQG
// module chunks = 1